// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"5c8ce6f0","573":"b220c5c9"}[chunkId] + ".chunk.js";
};